import { render } from "./template_sms.vue?vue&type=template&id=e77b3cc0&scoped=true"
import script from "./template_sms.vue?vue&type=script&lang=js"
export * from "./template_sms.vue?vue&type=script&lang=js"

import "./template_sms.vue?vue&type=style&index=0&id=e77b3cc0&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77b3cc0"]])

export default __exports__